// Generated types for ControlFlow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLBehaviorReadAPI, SysMLBehaviorWriteAPI } from './sysmlbehavior';
import { SysMLBehaviorReadAPISchemaObject, SysMLBehaviorWriteAPISchemaObject } from './sysmlbehavior';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ControlFlowReadAPI extends SysMLBehaviorReadAPI {
  /** Type of control signal */
  signal_type?: string | null;
}

export interface ControlFlowWriteAPI extends SysMLBehaviorWriteAPI {
  /** Type of control signal */
  signal_type?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ControlFlowReadAPISchema: z.ZodType<ControlFlowReadAPI> = SysMLBehaviorReadAPISchemaObject.extend({
  signal_type: z.string().nullable().optional(),
}).passthrough();

export const ControlFlowWriteAPISchema: z.ZodType<ControlFlowWriteAPI> = SysMLBehaviorWriteAPISchemaObject.extend({
  signal_type: z.string().nullable().optional(),
}).passthrough();
